"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Grid = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var utilities_1 = require("../../utilities");
var GridColumn_1 = require("./GridColumn");
var GridRow_1 = require("./GridRow");
var GridDefaultColumnsCount = 12;
var Grid = function (_a) {
    var _b;
    var celled = _a.celled, centered = _a.centered, children = _a.children, className = _a.className, _c = _a.columns, columns = _c === void 0 ? GridDefaultColumnsCount : _c, divided = _a.divided, doubling = _a.doubling, _d = _a.el, GridElement = _d === void 0 ? 'div' : _d, padded = _a.padded, relaxed = _a.relaxed, reversed = _a.reversed, stackable = _a.stackable, stretched = _a.stretched, textAlign = _a.textAlign, verticalAlign = _a.verticalAlign, props = __rest(_a, ["celled", "centered", "children", "className", "columns", "divided", "doubling", "el", "padded", "relaxed", "reversed", "stackable", "stretched", "textAlign", "verticalAlign"]);
    // Composing classes out of "reversed" prop
    var reversedSet = new Set(typeof reversed === 'string'
        ? reversed.trim().split(' ').filter(Boolean)
        : []);
    var reversedClasses = ['mobile', 'tablet', 'desktop']
        .filter(function (device) { return reversedSet.has(device); })
        .map(function (device) {
        return reversedSet.has('vertically')
            ? "Grid--" + device + "-vertically-reversed"
            : "Grid--" + device + "-reversed";
    });
    var GridClasses = classnames_1.default('Grid', className, reversedClasses, (_b = {
            'Grid--celled': celled,
            'Grid--internally-celled': celled === 'internally',
            'Grid--centered': centered
        },
        _b["Grid--" + utilities_1.columnsToNumeral(columns) + "-columns"] = utilities_1.columnsToNumeral(columns),
        _b["Grid--equal-width Grid--" + utilities_1.columnsToNumeral(GridDefaultColumnsCount) + "-columns"] = columns === 'equal',
        _b['Grid--divided'] = divided,
        _b['Grid--vertically-divided'] = divided === 'vertically',
        _b['Grid--doubling'] = doubling,
        _b['Grid--padded'] = padded,
        _b['Grid--vertically-padded'] = padded === 'vertically',
        _b['Grid--horizontally-padded'] = padded === 'horizontally',
        _b['Grid--relaxed'] = relaxed,
        _b['Grid--very-relaxed'] = relaxed === 'very',
        _b['Grid--stackable'] = stackable,
        _b['Grid--stretched'] = stretched,
        _b["Grid--text-align-" + textAlign] = textAlign,
        _b["Grid--vertical-align-" + verticalAlign] = verticalAlign,
        _b));
    return (react_1.default.createElement(GridElement, __assign({ className: GridClasses }, props), children));
};
exports.Grid = Grid;
exports.Grid.Column = GridColumn_1.GridColumn;
exports.Grid.Row = GridRow_1.GridRow;
//# sourceMappingURL=Grid.js.map